import { computed } from 'vue';
import { viewportWidth } from './getViewportSize';

export const isMobile = computed(() => viewportWidth.value <= 640); // computed to make boolean readonly
export const isLarge = computed(() => viewportWidth.value > 1024);
export const isExtraLarge = computed(() => viewportWidth.value > 1200);
